import { DescribeMissingField } from "../../utils/missingFields.utils";
import { AssetExpensesFormValues } from "./ExpensesView.types";

export const describeMissingExpenseField: DescribeMissingField<AssetExpensesFormValues> = ({ field }) => ({
  path: field,
});
